import { SectionHeader } from '../common/section-header'
import { CoachOrb, TutorMediaPreview, tutorMediaFor, tutorMediaByteSize } from '@speaking-coach/ui'
import { runtimeEnvironment } from '../config/runtime-environment'

const labels = { unavailable: 'Media unavailable', open: 'Open original', loading: 'Loading media…', dimensions: 'Dimensions', ratio: 'Ratio', size: 'File size', duration: 'Duration', metadataUnavailable: 'Not available', play: 'Play', pause: 'Pause', mute: 'Mute', unmute: 'Unmute', seek: 'Seek' }
function mediaUrl(path: string | null, origin: string | null) {
  if (!path || !origin) return null
  try {
    const address = new URL(path, origin)
    return ['http:', 'https:'].includes(address.protocol) ? address.href : null
  } catch { return null }
}
export function TutorMediaPanel({ contentKey, name }: { contentKey: string; name: string }) {
  const media = tutorMediaFor(contentKey)
  const origin = runtimeEnvironment().webBaseUrl
  const url = (path: string | null) => mediaUrl(path, origin)
  return <section className="space-y-4 rounded-token-card border border-border-default bg-surface-elev p-5" aria-labelledby="tutor-media-heading">
    <SectionHeader id="tutor-media-heading" title="Tutor media" />
    <p className="text-body text-text-secondary">Current media used in the learner app. Media is separate from saved Tutor revisions.</p>
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <TutorMediaPreview kind="image" src={url(media.portrait)} label="Portrait" accessibleLabel={`${name} · Portrait`} byteSize={tutorMediaByteSize(media.portrait)} locale="en" labels={labels} />
      <TutorMediaPreview kind="image" src={url(media.still)} label="Still" accessibleLabel={`${name} · Still`} byteSize={tutorMediaByteSize(media.still)} locale="en" labels={labels} />
      <TutorMediaPreview kind="video" src={url(media.listening)} poster={url(media.portrait) ?? undefined} label="Listening" accessibleLabel={`${name} · Listening`} byteSize={tutorMediaByteSize(media.listening)} locale="en" labels={labels} muted />
      <TutorMediaPreview kind="video" src={url(media.speaking)} poster={url(media.portrait) ?? undefined} label="Speaking" accessibleLabel={`${name} · Speaking`} byteSize={tutorMediaByteSize(media.speaking)} locale="en" labels={labels} />
    </div>
  </section>
}

export function TutorIdentityOrb({ contentKey, name, size = 64 }: { contentKey: string; name: string; size?: number }) {
  const path = tutorMediaFor(contentKey).portrait
  const origin = runtimeEnvironment().webBaseUrl
  return <div className="shrink-0 p-2"><CoachOrb coach={{ name, initial: name.charAt(0), photo: mediaUrl(path, origin) ?? undefined }} size={size} /></div>
}
